module.exports = __webpack_public_path__ + "static/media/downloadAppStore.2928664f.svg";